export default __webpack_public_path__ + "0c77bd6f87eda8fb289d9b7ae35668b2.png";